import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { formatDate } from 'clipsal-cortex-utils/src/formatting/formatting';
import { formatDollarsCents } from 'clipsal-cortex-utils/src/formatting/number-formatting';

import { DateRangeType } from '../../../../common/components/DateRangeTypePicker';
import { useGetSavingsQuery } from '../../../savings/savingsApi';
import { selectCurrentDayForSite } from '../../../site/siteSlice';
import { HomePageWidgetTileProps } from '../HomePageWidgetTile';
import { GenericHomePageWidgetTile } from './GenericHomePageWidgetTile';

export function SavingsWidgetTile({ item, index, isEditing, onRemoveGridItem }: HomePageWidgetTileProps) {
  const currentDay = useSelector(selectCurrentDayForSite);
  const { data: savingsData, isLoading: isSavingsLoading } = useGetSavingsQuery(currentDay, DateRangeType.Day);
  const totalSaved = useMemo(() => {
    return savingsData.find((dailySavings) => dailySavings.date === formatDate(currentDay))?.total_saved || 0;
  }, [currentDay, savingsData]);
  const { t } = useTranslation();

  return (
    <GenericHomePageWidgetTile
      isLoaded={!isSavingsLoading}
      item={{
        ...item,
        status: totalSaved ? formatDollarsCents(totalSaved) : '',
        title: totalSaved ? t("Widgets.Today's Savings.title") : t("Widgets.Today's Savings.savings"),
      }}
      index={index}
      isEditing={isEditing}
      onRemoveGridItem={onRemoveGridItem}
    />
  );
}
